module.exports = __webpack_public_path__ + "static/plant.b5c7228f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/floaters/plant.png
// module id = 1475
// module chunks = 168707334958949